import React, { Component } from "react";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";

export default class HeaderImgSection extends Component {
  render() {
    const { imageUuid, onUpload, onDelete } = this.props;
    return (
      <section className="project-cover-section">
        <h3 className="project-subtitle">Imagen del proyecto</h3>
        <div className="project-cover-uploader">
          <MfmImageUploader
            inputId="project-cover-uploader"
            uuid={imageUuid || null}
            appCode="TEAN"
            library="proyectos"
            size="medium"
            mediaFormat="60/19"
            mediaFrameSize="1200x380"
            extraPersistFormats={["ratio:16:9"]}
            allowPicker
            onUpload={(result) => onUpload && onUpload(result.uuid)}
            onDelete={() => onDelete && onDelete()}
          />
        </div>
      </section>
    );
  }
}
